import { useQuery } from '@tanstack/react-query';
import { container } from '@infrastructure/container';
import { ListingCountry } from '@domain/product/models/ListingCountry';

export const useListingCountries = () => {
  const { data, isLoading, error } = useQuery<ListingCountry[]>({
    queryKey: ['listing-countries'],
    queryFn: async () => {
      const result = await container.productRepository.getListingCountries();
      if (result.status === 'error') throw new Error(result.error.message);
      return result.data;
    },
  });

  return {
    countries: data ?? [],
    isLoading,
    error,
  };
};
